module.exports = __webpack_public_path__ + "static/media/bytt-no-12.29dad942.mp3";